/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1Boolean,
  ApiResponse1Object,
  ApiResponse1SignInResponse,
  ApiResponse1SignUpResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
  RevisdomAPIViewModelsSignInRequest,
  RevisdomAPIViewModelsSignUpRequest,
} from '../models/index';
import {
    ApiResponse1BooleanFromJSON,
    ApiResponse1BooleanToJSON,
    ApiResponse1ObjectFromJSON,
    ApiResponse1ObjectToJSON,
    ApiResponse1SignInResponseFromJSON,
    ApiResponse1SignInResponseToJSON,
    ApiResponse1SignUpResponseFromJSON,
    ApiResponse1SignUpResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
    RevisdomAPIViewModelsSignInRequestFromJSON,
    RevisdomAPIViewModelsSignInRequestToJSON,
    RevisdomAPIViewModelsSignUpRequestFromJSON,
    RevisdomAPIViewModelsSignUpRequestToJSON,
} from '../models/index';

export interface ApiAuthForgotGetRequest {
    email?: string;
}

export interface ApiAuthSigninPostRequest {
    revisdomAPIViewModelsSignInRequest?: RevisdomAPIViewModelsSignInRequest;
}

export interface ApiAuthSignupPostRequest {
    revisdomAPIViewModelsSignUpRequest?: RevisdomAPIViewModelsSignUpRequest;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * ...
     * Parola sıfırlama maili için endpoint.
     */
    async apiAuthForgotGetRaw(requestParameters: ApiAuthForgotGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Auth/forgot`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * ...
     * Parola sıfırlama maili için endpoint.
     */
    async apiAuthForgotGet(requestParameters: ApiAuthForgotGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiAuthForgotGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bu endpoint, kullanıcının oturumunu sonlandırır ve authentication cookie\'lerini temizler.
     * Kullanıcı çıkışı yapar
     */
    async apiAuthLogoutPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Bu endpoint, kullanıcının oturumunu sonlandırır ve authentication cookie\'lerini temizler.
     * Kullanıcı çıkışı yapar
     */
    async apiAuthLogoutPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiAuthLogoutPostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Örnek istek:                    POST /api/auth/signin      {          \"email\": \"john@example.com\",          \"password\": \"strongpassword123\"      }
     * Kullanıcı girişi yapar
     */
    async apiAuthSigninPostRaw(requestParameters: ApiAuthSigninPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1SignInResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Auth/signin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsSignInRequestToJSON(requestParameters['revisdomAPIViewModelsSignInRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1SignInResponseFromJSON(jsonValue));
    }

    /**
     * Örnek istek:                    POST /api/auth/signin      {          \"email\": \"john@example.com\",          \"password\": \"strongpassword123\"      }
     * Kullanıcı girişi yapar
     */
    async apiAuthSigninPost(requestParameters: ApiAuthSigninPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1SignInResponse> {
        const response = await this.apiAuthSigninPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Örnek istek:                    POST /api/auth/signup      {          \"firstName\": \"John\",          \"lastName\": \"Doe\",          \"email\": \"john@example.com\",          \"title\": \"johndoe\",          \"password\": \"strongpassword123\",          \"role\": 0      }
     * Yeni kullanıcı kaydı oluşturur
     */
    async apiAuthSignupPostRaw(requestParameters: ApiAuthSignupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1SignUpResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Auth/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsSignUpRequestToJSON(requestParameters['revisdomAPIViewModelsSignUpRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1SignUpResponseFromJSON(jsonValue));
    }

    /**
     * Örnek istek:                    POST /api/auth/signup      {          \"firstName\": \"John\",          \"lastName\": \"Doe\",          \"email\": \"john@example.com\",          \"title\": \"johndoe\",          \"password\": \"strongpassword123\",          \"role\": 0      }
     * Yeni kullanıcı kaydı oluşturur
     */
    async apiAuthSignupPost(requestParameters: ApiAuthSignupPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1SignUpResponse> {
        const response = await this.apiAuthSignupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
